var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"course content"},[_c('div',{staticClass:"curr_tab"},[_c('Table',{ref:"selection",attrs:{"loading":_vm.loading,"border":"","columns":_vm.columns,"data":_vm.courseList}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }